// English translations
const en = {
  siteName: 'Brothers Phone',
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    back: 'Back',
    yes: 'Yes',
    no: 'No',
    add: 'Add',
    remove: 'Remove',
    submit: 'Submit',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    home: 'Home',
    dashboard: 'Dashboard',
    products: 'Products',
    categories: 'Categories',
    orders: 'Orders',
    cart: 'Cart',
    wishlist: 'Wishlist',
    addToCart: 'Add to Cart',
    addToWishlist: 'Add to Wishlist',
    viewMore: 'View More',
    outOfStock: 'Out of Stock',
    addedToCart: 'Product added to cart!',
    addedToWishlist: 'Product added to wishlist!',
    addToCartError: 'Failed to add product to cart',
    addToWishlistError: 'Failed to add product to wishlist',
    loginRequired: 'Please sign in to add items to your wishlist',
    profile: 'Profile',
    settings: 'Settings',
    admin: 'Admin',
  },
  navigation: {
    home: 'Home',
    shop: 'Shop',
    news: 'News',
    about: 'About',
    contact: 'Contact',
    myAccount: 'My Account',
    admin: 'Admin Dashboard',
    profile: 'Profile',
    orders: 'Orders',
    wishlist: 'Wishlist',
    cart: 'Cart',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
  },
  auth: {
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: 'Don\'t have an account?',
    loginSuccessful: 'Login successful!',
    registrationSuccessful: 'Registration successful!',
    logoutSuccessful: 'You have been logged out.',
    invalidCredentials: 'Invalid credentials.',
    unauthorizedAccess: 'Unauthorized access.',
    sessionExpired: 'Your session has expired. Please login again.',
  },
  products: {
    title: 'Products',
    addToCart: 'Add to Cart',
    addToWishlist: 'Add to Wishlist',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    price: 'Price',
    quantity: 'Quantity',
    description: 'Description',
    name: 'Name',
    category: 'Category',
    searchPlaceholder: 'Search products...',
    filter: 'Filter',
    sort: 'Sort',
    noProductsFound: 'No products found.',
    createNew: 'Create New Product',
    edit: 'Edit Product',
    delete: 'Delete Product',
    deleteConfirmation: 'Are you sure you want to delete this product?',
  },
  cart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty.',
    continueShipping: 'Continue Shipping',
    subtotal: 'Subtotal',
    total: 'Total',
    checkout: 'Checkout',
    removeFromCart: 'Remove from Cart',
    updateQuantity: 'Update Quantity',
    itemAdded: 'Item added to cart!',
    itemRemoved: 'Item removed from cart!',
    itemUpdated: 'Cart updated!',
  },
  orders: {
    title: 'Orders',
    orderNumber: 'Order Number',
    date: 'Date',
    status: 'Status',
    total: 'Total',
    details: 'View Details',
    noOrdersFound: 'No orders found.',
    createNew: 'Create New Order',
    placeOrder: 'Place Order',
    orderPlaced: 'Order placed successfully!',
    orderCancelled: 'Order cancelled!',
    cancelOrder: 'Cancel Order',
    pending: 'Pending',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  },
  news: {
    title: 'Latest News & Updates',
    subtitle: 'Stay updated with our latest products and announcements',
    featuredImage: 'Featured Image',
    logoAnimation: 'Our Brand',
    socialMedia: 'Follow Us',
    youtubeVideos: 'Latest Videos',
    noContent: 'No news content available at the moment.',
    managePage: 'Manage News Page',
    updateContent: 'Update Content',
    uploadImage: 'Upload Image',
    addVideo: 'Add YouTube Video',
    videoUrl: 'YouTube Video URL',
    socialLinks: 'Social Media Links',
    facebook: 'Facebook',
    instagram: 'Instagram',
    twitter: 'Twitter',
    youtube: 'YouTube',
    tiktok: 'TikTok',
  },
  footer: {
    about: 'About Us',
    contact: 'Contact Us',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    copyright: '© 2025 Brothers Phone. All rights reserved.',
  },
};

export default en;
